import { render, staticRenderFns } from "./ChangeSeat.vue?vue&type=template&id=7dfca3fa&scoped=true&"
import script from "./ChangeSeat.vue?vue&type=script&lang=js&"
export * from "./ChangeSeat.vue?vue&type=script&lang=js&"
import style0 from "./ChangeSeat.vue?vue&type=style&index=0&id=7dfca3fa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dfca3fa",
  null
  
)

export default component.exports